
import { GET_EDUCATIONAL_PULSES } from '@marketplace/graphql/educationPulses.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

// Module-level cache shared across all PulseIndicator instances
let cachedPulses = null
let cachedForRoute = null
let fetchPromise = null

export default {
    name: 'PulseIndicator',
    props: {
        pulseIds: {
            type: Array,
            required: true,
        },
        idPrefix: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isAnimating: false,
            educationalPulses: cachedPulses || [],
            isLoading: cachedPulses === null,
        }
    },
    computed: {
        pulseSeen() {
            if (this.educationalPulses.length === 0) {
                return null
            }

            const seenForAllPulseIds = this.pulseIds.every((pulseId) => {
                const seen = !this.educationalPulses.some(
                    (pulse) => pulse.pulseId === pulseId
                )
                EventBus.$emit(
                    this.idPrefix + ':pulseSeenChanged:' + pulseId,
                    seen
                )

                return seen
            })

            return seenForAllPulseIds
        },
    },

    watch: {
        $route(to, from) {
            if (to.path !== from.path) {
                this.fetchEducationalPulses(true)
            }
        },
    },

    created() {
        this.fetchEducationalPulses(false)
    },

    methods: {
        visibilityChanged(isVisible) {
            if (isVisible) {
                setTimeout(() => {
                    this.isAnimating = true
                }, 500)
            } else {
                this.isAnimating = false
            }
        },
        fetchEducationalPulses(forceRefresh) {
            const currentRoute = this.$route.path

            if (!forceRefresh && cachedForRoute === currentRoute && cachedPulses !== null) {
                this.educationalPulses = cachedPulses
                this.isLoading = false
                return
            }

            if (!forceRefresh && fetchPromise && cachedForRoute === currentRoute) {
                fetchPromise.then(() => {
                    this.educationalPulses = cachedPulses || []
                    this.isLoading = false
                })
                return
            }

            cachedForRoute = currentRoute
            fetchPromise = this.$apollo
                .query({
                    query: GET_EDUCATIONAL_PULSES,
                    fetchPolicy: 'no-cache',
                })
                .then(({ data }) => {
                    cachedPulses = data.getAvailableEducationalPulses
                    this.educationalPulses = cachedPulses
                    this.isLoading = false
                })
                .catch((error) => {
                    console.error('Error fetching educationalPulses:', error)
                    this.isLoading = false
                })
        },
    },
}
